import LoadingComponent from "../../../../../components/LoadingComponent.jsx";
import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {FilterContext} from "../../../../../components/filters/DashboardFilterContextProvider.jsx";
import {GlobalContext} from "../../../../../utils/context/GlobalContextProvider.jsx";
import {ErpCalculationApi} from "../../../../../api/authority/generated/index";
import toast from "react-hot-toast";
import {useErrorTranslation} from "../../../../../api/utilities/translateErrorMessage.js";
import {useRenderNumber} from "../../../../../api/utilities/useValueRenderers.js";
import useUserSettings from "../../../../../utils/useUserSettings.js";
import DataGrid2 from "../../../../../components/datagrid/DataGrid2.jsx";

export default function DiscountPerformanceTable({project}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let {since, until, centresAllowListed, domainsAllowListed} = useContext(FilterContext);
    let {getAuthorityConfiguration} = useContext(GlobalContext);

    let renderNumber = useRenderNumber();

    let [data, setData] = useState(null);

    let [userSettings] = useUserSettings();

    let [discountDataGridSource, setDiscountDataGridSource] = useState(null)


    let columns = [
        {
            name: 'name',
            header: t('discounts.discount'),
            defaultFlex: 4,
        },
        {
            name: 'amount',
            textAlign: 'end',
            header: t('orders.amount'),
        }
    ];

    useEffect(() => {
        if (!project) {
            return;
        }

        setData(null);
        setDiscountDataGridSource(null);

        let authorityConfiguration = getAuthorityConfiguration();

        new ErpCalculationApi(authorityConfiguration)
            .discountPerformance({
                projectId: project.id,
                erpFilter: {
                    since: since.format('YYYY-MM-DD'),
                    until: until.format('YYYY-MM-DD'),
                    selectedCentreIds: centresAllowListed,
                    selectedDomainIds: domainsAllowListed,
                },
            })
            .then(setData)
            .catch(e => et(e).then((message) => { if (message) toast.error(message); }));

    }, [project?.id, since, until, centresAllowListed, domainsAllowListed]);

    useEffect(() => {
        let newDiscountDataGridSource = [];

        for (let discount of Object.values(data?.discounts ?? [])) {
            newDiscountDataGridSource.push({
                name: discount.name,
                amount: renderNumber(userSettings?.isMarketing ? discount.amountGross : discount.amountNet),
            });
        }

        setDiscountDataGridSource(newDiscountDataGridSource);
    }, [data, userSettings]);

    return (<LoadingComponent
            loading={!data || !discountDataGridSource}
            className="comp__roundedBox flex flex-col justify-between col-span-12 xl:col-span-5 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700"
        >
            <header
                className={'px-5 py-4 border-b border-gray-100 dark:border-gray-700/60'}>
                <h2 className={'font-semibold text-gray-800 dark:text-gray-100'}>
                    {t('discounts.discount-usage')}
                </h2>
            </header>
            <div className={'p-3'}>
                <div className="chart-container">
                    <DataGrid2
                        columns={columns}
                        dataSource={discountDataGridSource ?? []}
                    />
                </div>
            </div>
        </LoadingComponent>
    );

}
